import { render } from "./SmsSenderNames.vue?vue&type=template&id=62aa951c&scoped=true"
import script from "./SmsSenderNames.vue?vue&type=script&lang=js"
export * from "./SmsSenderNames.vue?vue&type=script&lang=js"

import "./SmsSenderNames.vue?vue&type=style&index=0&id=62aa951c&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62aa951c"]])

export default __exports__